/* Mini-cart drawer — AJAX add-to-cart with the drawer as feedback.
   Progressive enhancement: without this file, product forms post to
   /cart/add and land on the cart page, exactly as before. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-drawer]');
  if (!drawer || !window.fetch) return;

  var linesEl = drawer.querySelector('[data-drawer-lines]');
  var totalEl = drawer.querySelector('[data-drawer-total]');
  var countEl = drawer.querySelector('[data-drawer-count]');
  var shipEl  = drawer.querySelector('[data-drawer-ship]');
  var noteEl  = drawer.querySelector('[data-drawer-note]');
  var money = function (cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  };

  /* ---- Open / close ---------------------------------------------------- */
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetHeight;   /* force reflow so the transition runs even in throttled tabs */
    drawer.classList.add('is-open');
    document.documentElement.classList.add('tih-drawer-lock');
    var x = drawer.querySelector('.tih-drawer__x');
    if (x) x.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('tih-drawer-lock');
    setTimeout(function () { drawer.hidden = true; }, 200);
    if (lastFocus) lastFocus.focus();
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* ---- Render from /cart.js -------------------------------------------- */
  function render(cart) {
    var badge = document.querySelector('[data-cart-count]');
    if (badge) badge.textContent = cart.item_count;
    if (countEl) countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (totalEl) totalEl.textContent = money(cart.total_price);

    if (shipEl) {
      var threshold = parseInt(shipEl.getAttribute('data-threshold'), 10) || 0;
      var remaining = threshold - cart.total_price;
      var pct = threshold ? Math.min(100, Math.round(cart.total_price / threshold * 100)) : 0;
      shipEl.classList.toggle('is-met', remaining <= 0);
      var left = (shipEl.getAttribute('data-left') || 'Nog|tot gratis verzending').split('|');
      var got = (shipEl.getAttribute('data-got') || 'Je bestelling wordt|gratis verzonden').split('|');
      var txt = shipEl.querySelector('[data-ship-txt]');
      txt.textContent = '';
      var strong = document.createElement('strong');
      strong.textContent = remaining > 0 ? money(remaining) : got[1];
      txt.append((remaining > 0 ? left[0] : got[0]) + ' ', strong, remaining > 0 ? ' ' + left[1] : '.');
      /* The cost under the total follows the cart: delivery €6,50 below the threshold, free above it. */
      if (noteEl) noteEl.textContent = noteEl.getAttribute(remaining > 0 ? 'data-paid' : 'data-free');
      var track = shipEl.querySelector('.tih-shipbar__track');
      if (track) track.setAttribute('aria-valuenow', pct);
      shipEl.querySelector('[data-ship-fill]').style.width = pct + '%';
    }

    if (!cart.items.length) {
      linesEl.innerHTML = '<p class="tih-drawer__empty">Je winkelwagen is leeg.</p>';
      return;
    }
    linesEl.innerHTML = cart.items.map(function (it) {
      return '<div class="tih-drawer__line" data-key="' + it.key + '">' +
        '<a class="tih-drawer__thumb" href="' + it.url + '" tabindex="-1" aria-hidden="true">' +
          (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="tih-drawer__info">' +
          (it.vendor ? '<span class="tih-drawer__vendor">' + it.vendor + '</span>' : '') +
          '<a class="tih-drawer__title" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title ? '<span class="tih-drawer__variant">' + it.variant_title + '</span>' : '') +
          '<div class="tih-qty tih-qty--sm">' +
            '<button type="button" class="tih-qty__btn" data-line-step="-1" aria-label="Eén minder">&minus;</button>' +
            '<input class="tih-qty__input" type="number" value="' + it.quantity + '" min="0" readonly aria-label="Aantal">' +
            '<button type="button" class="tih-qty__btn" data-line-step="1" aria-label="Eén meer">+</button>' +
          '</div>' +
        '</div>' +
        '<span class="tih-drawer__price tih-price">' + money(it.final_line_price) + '</span>' +
      '</div>';
    }).join('');
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
  }

  /* ---- Line quantity from inside the drawer ----------------------------- */
  linesEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-step]');
    if (!btn) return;
    var line = btn.closest('[data-key]');
    var input = line.querySelector('.tih-qty__input');
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-line-step'), 10));
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: next })
    }).then(function (r) { return r.json(); }).then(render);
  });

  /* ---- Intercept every product form ------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form.action || '').match(/\/cart\/add/)) return;
    e.preventDefault();

    var btn = form.querySelector('[name="add"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh();
      })
      .then(open)
      .catch(function () { form.submit(); })   // network trouble: original behaviour
      .finally(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
  });

  /* ---- Cart icon opens the drawer instead of navigating ----------------- */
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('[data-drawer-open]');
    if (!icon) return;
    e.preventDefault();
    refresh().then(open);
  });
})();
